import { formBuilderFieldsByType } from "../../Fields/index.js";
import { useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import warnOnce from "warn-once";
//#region src/modules/FormBuilder/components/FormBuilderFormRenderer/components/FieldFormRenderer.tsx
var FieldFormRenderer = ({ field }) => {
	const Component = useMemo(() => {
		const component = formBuilderFieldsByType[field.type]?.FormLayout;
		if (component) return component;
		warnOnce(true, `<FormComponent field={{ type: "${field.type}", ...}} /> - not a recognized field type`);
		return () => null;
	}, [field.type]);
	return /* @__PURE__ */ jsx(Component, { config: field });
};
//#endregion
export { FieldFormRenderer };

//# sourceMappingURL=FieldFormRenderer.js.map